const LocalStorageService = (function () {
  let _service;
  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }
  function setDataToLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  function _setToken(tokenObj) {
    localStorage.setItem("access_token", tokenObj.access_token);
    localStorage.setItem("refresh_token", tokenObj.refresh_token);
  }
  function _getUserData() {
    const userData = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")) : {};
    return userData;
  }
  function _getExpiryDate() {
    const expiryDate = !!JSON.parse(localStorage.getItem("userData")) && !!JSON.parse(localStorage.getItem("userData")).session_expiry_date && JSON.parse(localStorage.getItem("userData")).session_expiry_date !== "" ? JSON.parse(localStorage.getItem("userData")).session_expiry_date : "";
    return expiryDate;
  }
  function _getUserProduct() {
    const currentProduct = !!JSON.parse(localStorage.getItem("userData")) && !!JSON.parse(localStorage.getItem("userData")).current_product && JSON.parse(localStorage.getItem("userData")).current_product !== "" ? JSON.parse(localStorage.getItem("userData")).current_product : "";
    return currentProduct;
  }
  function _getOptionId() {
    const currentOptionId = !!JSON.parse(localStorage.getItem("userData")) && !!JSON.parse(localStorage.getItem("userData")).option_id && JSON.parse(localStorage.getItem("userData")).option_id !== "" ? JSON.parse(localStorage.getItem("userData")).option_id : "";
    return currentOptionId;
  }
  function _getNavigate() {
    const navigate = !!JSON.parse(localStorage.getItem("userData")) && !!JSON.parse(localStorage.getItem("userData")).navigate && JSON.parse(localStorage.getItem("userData")).navigate !== "" ? JSON.parse(localStorage.getItem("userData")).navigate : "";
    return navigate;
  }
  function _getAccessToken() {
    const parsedUserData = JSON.parse(localStorage.getItem("userData")) || {};
    const ssoToken = parsedUserData.sso_token || parsedUserData.ssoToken || "";
    return ssoToken;
  }
  function _getUserCurrentPlan() {
    const userCurrentPlan = !!JSON.parse(localStorage.getItem("userCurrentPlan")) && !!JSON.parse(localStorage.getItem("userCurrentPlan")).user_active_plan && JSON.parse(localStorage.getItem("userCurrentPlan")).user_active_plan !== "" ? JSON.parse(localStorage.getItem("userCurrentPlan")).user_active_plan : "";
    return userCurrentPlan;
  }
  function _getUserDetails() {
    const userDetails = !!JSON.parse(localStorage.getItem("userDetails")) && JSON.parse(localStorage.getItem("userDetails")) !== "" ? JSON.parse(localStorage.getItem("userDetails")) : "";
    return userDetails;
  }
  function _getUserUSExportsArrivalDate() {
    const userArrivalDate = !!JSON.parse(localStorage.getItem("us_export_arrival_date")) && JSON.parse(localStorage.getItem("us_export_arrival_date")) !== "" ? JSON.parse(localStorage.getItem("us_export_arrival_date")) : "";
    return userArrivalDate;
  }
  function _getUserUSExportsArrivalDateSetTime() {
    const usExportsArrivalDateTime = !!JSON.parse(localStorage.getItem("us_export_arrival_date")) && !!JSON.parse(localStorage.getItem("us_export_arrival_date")).setTime && JSON.parse(localStorage.getItem("us_export_arrival_date")).setTime !== "" ? JSON.parse(localStorage.getItem("us_export_arrival_date")).setTime : "";
    return usExportsArrivalDateTime;
  }
  function _getUserArrivalDate() {
    const userArrivalDate = !!JSON.parse(localStorage.getItem("user_arrival_date")) && !!JSON.parse(localStorage.getItem("user_arrival_date")).userArrivalDate && JSON.parse(localStorage.getItem("user_arrival_date")).userArrivalDate !== "" ? JSON.parse(localStorage.getItem("user_arrival_date")).userArrivalDate : "";
    return userArrivalDate;
  }
  function _getColumbiaArrivalDate() {
    const columbiaArrivalDate = !!JSON.parse(localStorage.getItem("columbia_arrival_date")) && !!JSON.parse(localStorage.getItem("columbia_arrival_date")).userArrivalDate && JSON.parse(localStorage.getItem("columbia_arrival_date")).userArrivalDate !== "" ? JSON.parse(localStorage.getItem("columbia_arrival_date")).userArrivalDate : "";
    return columbiaArrivalDate;
  }
  function _getArgentinaArrivalDate() {
    const argentinaArrivalDate = !!JSON.parse(localStorage.getItem("argentina_arrival_date")) && !!JSON.parse(localStorage.getItem("argentina_arrival_date")).userArrivalDate && JSON.parse(localStorage.getItem("argentina_arrival_date")).userArrivalDate !== "" ? JSON.parse(localStorage.getItem("argentina_arrival_date")).userArrivalDate : "";
    return argentinaArrivalDate;
  }
  function _getPeruArrivalDate() {
    const peruArrivalDate = !!JSON.parse(localStorage.getItem("peru_arrival_date")) && !!JSON.parse(localStorage.getItem("peru_arrival_date")).userArrivalDate && JSON.parse(localStorage.getItem("peru_arrival_date")).userArrivalDate !== "" ? JSON.parse(localStorage.getItem("peru_arrival_date")).userArrivalDate : "";
    return peruArrivalDate;
  }
  function _getEcuadorArrivalDate() {
    const ecuadorArrivalDate = !!JSON.parse(localStorage.getItem("ecuador_arrival_date")) && !!JSON.parse(localStorage.getItem("ecuador_arrival_date")).userArrivalDate && JSON.parse(localStorage.getItem("ecuador_arrival_date")).userArrivalDate !== "" ? JSON.parse(localStorage.getItem("ecuador_arrival_date")).userArrivalDate : "";
    return ecuadorArrivalDate;
  }
  function _getUserArrivalDateSetTime() {
    const userArrivalDateTime = !!JSON.parse(localStorage.getItem("user_arrival_date")) && !!JSON.parse(localStorage.getItem("user_arrival_date")).setTime && JSON.parse(localStorage.getItem("user_arrival_date")).setTime !== "" ? JSON.parse(localStorage.getItem("user_arrival_date")).setTime : "";
    return userArrivalDateTime;
  }
  function _getColumbiaArrivalDateSetTime() {
    const comulbiaArrivalDateTime = !!JSON.parse(localStorage.getItem("columbia_arrival_date")) && !!JSON.parse(localStorage.getItem("columbia_arrival_date")).setTime && JSON.parse(localStorage.getItem("columbia_arrival_date")).setTime !== "" ? JSON.parse(localStorage.getItem("columbia_arrival_date")).setTime : "";
    return comulbiaArrivalDateTime;
  }
  function _getArgentinaArrivalDateSetTime() {
    const argentinaArrivalDateTime = !!JSON.parse(localStorage.getItem("argentina_arrival_date")) && !!JSON.parse(localStorage.getItem("argentina_arrival_date")).setTime && JSON.parse(localStorage.getItem("argentina_arrival_date")).setTime !== "" ? JSON.parse(localStorage.getItem("argentina_arrival_date")).setTime : "";
    return argentinaArrivalDateTime;
  }
  function _getPeruArrivalDateSetTime() {
    const peruArrivalDateTime = !!JSON.parse(localStorage.getItem("peru_arrival_date")) && !!JSON.parse(localStorage.getItem("peru_arrival_date")).setTime && JSON.parse(localStorage.getItem("peru_arrival_date")).setTime !== "" ? JSON.parse(localStorage.getItem("peru_arrival_date")).setTime : "";
    return peruArrivalDateTime;
  }
  function _getEcuadorArrivalDateSetTime() {
    const ecuadorArrivalDateTime = !!JSON.parse(localStorage.getItem("ecuador_arrival_date")) && !!JSON.parse(localStorage.getItem("ecuador_arrival_date")).setTime && JSON.parse(localStorage.getItem("ecuador_arrival_date")).setTime !== "" ? JSON.parse(localStorage.getItem("ecuador_arrival_date")).setTime : "";
    return ecuadorArrivalDateTime;
  }
  function _getUserMexicoArrivalDate() {
    const userArrivalDate = !!JSON.parse(localStorage.getItem("user_mexico_arrival_date")) && !!JSON.parse(localStorage.getItem("user_mexico_arrival_date")).userArrivalDate && JSON.parse(localStorage.getItem("user_mexico_arrival_date")).userArrivalDate !== "" ? JSON.parse(localStorage.getItem("user_mexico_arrival_date")).userArrivalDate : "";
    return userArrivalDate;
  }
  function _getUserMexicoArrivalDateSetTime() {
    const userArrivalDateTime = !!JSON.parse(localStorage.getItem("user_mexico_arrival_date")) && !!JSON.parse(localStorage.getItem("user_mexico_arrival_date")).setTime && JSON.parse(localStorage.getItem("user_mexico_arrival_date")).setTime !== "" ? JSON.parse(localStorage.getItem("user_mexico_arrival_date")).setTime : "";
    return userArrivalDateTime;
  }
  function _getSessionID() {
    const parsedUserData = JSON.parse(localStorage.getItem("userData")) || {};
    const sessionId = parsedUserData.session_id || parsedUserData.sessionId || "";
    return sessionId;
  }
  function _getSessionExpiryDate() {
    const session_expiry_date = !!JSON.parse(localStorage.getItem("userData")) && !!JSON.parse(localStorage.getItem("userData")).session_expiry_date && JSON.parse(localStorage.getItem("userData")).session_expiry_date !== "" ? JSON.parse(localStorage.getItem("userData")).session_expiry_date : "";
    return session_expiry_date;
  }

  function _getCompanyProfileDetails() {
    const data = !!JSON.parse(localStorage.getItem("companyProfileData")) && JSON.parse(localStorage.getItem("companyProfileData")) !== "" ? JSON.parse(localStorage.getItem("companyProfileData")) : "";
    return data;
  }

  function _getNotificationDetails() {
    return JSON.parse(localStorage.getItem("notification_details"));
  }

  function _setActiveTabIds(tabs) {
    return localStorage.setItem("activeTabIds", JSON.stringify(tabs));
  }

  function _getActiveTabIds() {
    return JSON.parse(localStorage.getItem("activeTabIds"));
  }

  function _notificationData() {
    return JSON.parse(localStorage.getItem("notification_Data"));
  }

  function _getRefreshToken() {
    return localStorage.getItem("refresh_token");
  }
  function _clearToken() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  }

  function _clearCompleteStorage() {
    localStorage.clear();
    sessionStorage.clear();
  }
  // Below Method is used CTA's
  function _clearFromPath() {
    localStorage.removeItem("from_path");
  }
  function _getFromPath() {
    const tempFromPath = !!JSON.parse(localStorage.getItem("from_path")) && !!JSON.parse(localStorage.getItem("from_path")).path && JSON.parse(localStorage.getItem("from_path")).path !== "" ? JSON.parse(localStorage.getItem("from_path")).path : "";
    return tempFromPath;
  }
  // End of the above Code
  //  Below code is for get the Reload Saved Search Data
  function _getReloadSavedSearchData() {
    const userDetails = !!JSON.parse(localStorage.getItem("reloadSavedSearch")) && JSON.parse(localStorage.getItem("reloadSavedSearch")) !== "" ? JSON.parse(localStorage.getItem("reloadSavedSearch")) : "";
    return userDetails;
  }
  function _clearReloadSavedSearchData() {
    localStorage.removeItem("reloadSavedSearch");
  }
  //  End of the above code
  // Below code is for the Download Analytics PDF
  function _setAnalyticsDownloadData(data) {
    localStorage.setItem("analyticsDownloadData", data);
  }
  function _getAnalyticsDownloadData() {
    const analyticsData = !!JSON.parse(localStorage.getItem("analyticsDownloadData")) && JSON.parse(localStorage.getItem("analyticsDownloadData")) !== "" ? JSON.parse(localStorage.getItem("analyticsDownloadData")) : "";
    return analyticsData;
  }
  function _clearAnalyticsDownloadData() {
    localStorage.removeItem("analyticsDownloadData");
  }
  // End of the above code
  // Below code is for the setting up the User Credit Details
  function _setUserCreditsDetails(data) {
    localStorage.setItem("userCreditDetails", data);
  }
  function _getUserCreditsDetails(data) {
    localStorage.setItem("", data);
    const userCreditData = !!JSON.parse(localStorage.getItem("userCreditDetails")) && JSON.parse(localStorage.getItem("userCreditDetails")) !== "" ? JSON.parse(localStorage.getItem("userCreditDetails")) : "";
    return userCreditData;
  }
  // End of the above code
  return {
    setUserCreditsDetails: _setUserCreditsDetails,
    getUserCreditsDetails: _getUserCreditsDetails,
    setAnalyticsDownloadData: _setAnalyticsDownloadData,
    getAnalyticsDownloadData: _getAnalyticsDownloadData,
    clearAnalyticsDownloadData: _clearAnalyticsDownloadData,
    getService: _getService,
    getUserData: _getUserData,
    setToken: _setToken,
    getOptionId: _getOptionId,
    getNavigate: _getNavigate,
    getUserProduct: _getUserProduct,
    getAccessToken: _getAccessToken,
    getUserCurrentPlan: _getUserCurrentPlan,
    getUserDetails: _getUserDetails,
    getUserArrivalDate: _getUserArrivalDate,
    getColumbiaArrivalDate: _getColumbiaArrivalDate,
    getArgentinaArrivalDate: _getArgentinaArrivalDate,
    getPeruArrivalDate: _getPeruArrivalDate,
    getEcuadorArrivalDate: _getEcuadorArrivalDate,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    getSessionID: _getSessionID,
    setDataToLocalStorage: setDataToLocalStorage,
    clearCompleteStorage: _clearCompleteStorage,
    getSessionExpiryDate: _getSessionExpiryDate,
    clearFromPath: _clearFromPath,
    getFromPath: _getFromPath,
    getExpiryDate: _getExpiryDate,
    getUserArrivalDateSetTime: _getUserArrivalDateSetTime,
    getColumbiaArrivalDateSetTime: _getColumbiaArrivalDateSetTime,
    getArgentinaArrivalDateSetTime: _getArgentinaArrivalDateSetTime,
    getPeruArrivalDateSetTime: _getPeruArrivalDateSetTime,
    getEcuadorArrivalDateSetTime: _getEcuadorArrivalDateSetTime,
    getReloadSavedSearchData: _getReloadSavedSearchData,
    clearReloadSavedSearchData: _clearReloadSavedSearchData,
    getUserMexicoArrivalDate: _getUserMexicoArrivalDate,
    getUserMexicoArrivalDateSetTime: _getUserMexicoArrivalDateSetTime,
    getUserUSExportsArrivalDate: _getUserUSExportsArrivalDate,
    getUserUSExportsArrivalDateSetTime: _getUserUSExportsArrivalDateSetTime,
    getCompanyProfileDetails: _getCompanyProfileDetails,
    getNotificationDetails: _getNotificationDetails,
    getnotificationData: _notificationData,
    getActiveTabIds: _getActiveTabIds,
    setActiveTabIds: _setActiveTabIds,
  };
})();
export default LocalStorageService;
